//imports
import Headroom from "headroom.js";
import GLightbox from 'glightbox';
import 'slick-carousel';
import AOS from 'aos';
import Rellax from 'rellax';




// lazysizes
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import 'lazysizes/plugins/bgset/ls.bgset';
import './navigation.js';





(function () {
  'use strict';

  const brand   = document.querySelector('.site-header__brand');
  const ticker  = document.querySelector('.site-header__ticker');
  const nav     = document.querySelector('.site-header__nav');

  if (!brand || !nav) return;

  // Sentinel einmalig erstellen
  const sentinel = document.createElement('div');
  sentinel.className = 'site-header__nav-sentinel';
  nav.insertAdjacentElement('afterend', sentinel);

  // Höhe einmalig messen (nach DOMContentLoaded ist das Layout stabil)
  // und bei Resize aktualisieren
  let navHeight = 0;

  function measureNav() {
    // Kurz sicherstellen dass nav im Flow ist für korrekte Messung
    const wasFixed = nav.classList.contains('is-fixed');
    if (wasFixed) {
      nav.classList.remove('is-fixed');
      sentinel.style.height = '0px';
    }
    navHeight = nav.offsetHeight;
    if (wasFixed) {
      sentinel.style.height = navHeight + 'px';
      nav.classList.add('is-fixed');
    }
  }

  measureNav();
  window.addEventListener('resize', measureNav);

  function applyFixed() {
    // 1. Zuerst Sentinel auf exakte Höhe setzen → kein Sprung
    sentinel.style.height = navHeight + 'px';
    // 2. Dann Nav aus dem Flow nehmen
    nav.classList.add('is-fixed');
    document.body.style.setProperty('--nav-height', navHeight + 'px');
  }

  function removeFixed() {
    // 1. Zuerst Nav zurück in den Flow
    nav.classList.remove('is-fixed');
    // 2. Dann Sentinel leeren
    sentinel.style.height = '0px';
    document.body.style.setProperty('--nav-height', '0px');
  }

  const observeTarget = ticker || brand;

  const observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) {
          applyFixed();
        } else {
          removeFixed();
        }
      });
    },
    {
      root: null,
      threshold: 0,
      rootMargin: '0px'
    }
  );

  observer.observe(observeTarget);
})();



$(document).ready(function($){





  $('.hero-slider').slick({
    dots: false,
    prevArrow: false,
    nextArrow: false,
    fade: true,
    autoplay: true,
    rows: 0,
});

$('.ticker').slick({
   dots: false,
   vertical: true,
   slidesToShow: 1,
   slidesToScroll: 1,
   verticalSwiping: true,
   prevArrow: false,
nextArrow: false,
autoplay: true,
autoplaySpeed: 2000,
 });

   var rellax = new Rellax('.rellax');


$('.hero-slider').on('beforeChange', function() {

   $('.headline').removeClass('fadeInLeft').hide();
   setTimeout(() => {
     $('.headline').addClass('fadeInLeft').show();

   }, 1000);

   $('.subheadline').removeClass('fadeInRight').hide();
   setTimeout(() => {
     $('.subheadline').addClass('fadeInRight').show();

   }, 1000);

 })



  $( '.card--event' ).hover(function() {
     $(this).toggleClass("hover");
  });

  //lightbox init
  const lightbox = GLightbox({
    touchNavigation: true,
    loop: true,
    slideEffect: 'fade'
});






  AOS.init();

});


/**
 * star-spin.js
 *
 * Lädt-Animation (Ease-Out) + Drag-Spin mit Momentum für das star.svg
 * im .site-header__right des Stadtpark-Open-Air-Themes.
 *
 * Einbinden via functions.php:
 *   wp_enqueue_script(
 *     'soa-star-spin',
 *     get_template_directory_uri() . '/dist/js/star-spin.js',
 *     [],          // keine Abhängigkeiten
 *     '1.0.0',
 *     true         // im Footer laden
 *   );
 */

(function () {
  'use strict';

  // ── Warten bis DOM bereit ist ──────────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', function () {

    // Ziel-Element: das <img> im .site-header__right
    const star = document.querySelector('.site-header__right-top img');
    if (!star) return;

    // ─────────────────────────────────────────────────────────────────────────
    // STATE
    // ─────────────────────────────────────────────────────────────────────────
    let currentAngle    = 0;    // aktueller Winkel in Grad
    let isDragging      = false;
    let lastX           = 0;
    let lastY           = 0;
    let angularVelocity = 0;    // Grad / ms
    let lastTimestamp   = 0;

    // ─────────────────────────────────────────────────────────────────────────
    // HELPERS
    // ─────────────────────────────────────────────────────────────────────────

    /** Mittelpunkt des Sterns in Viewport-Koordinaten */
    function starCenter() {
      const r = star.getBoundingClientRect();
      return { x: r.left + r.width / 2, y: r.top + r.height / 2 };
    }

    /** Winkel direkt per inline-style setzen (keine Animation) */
    function setAngle(deg) {
      currentAngle = deg;
      star.style.transform = 'rotate(' + deg + 'deg)';
    }

    /**
     * Laufende CSS-Animation einfrieren und aktuellen Winkel aus der
     * computed-Matrix auslesen, damit kein Sprung entsteht.
     */
    function freezeAngle() {
      const computed = window.getComputedStyle(star).transform;

      // Klassen entfernen → Animation stoppt
      star.classList.remove('star--load-spin', 'star--coasting', 'star--spinning');
      star.style.animation = 'none';

      if (computed && computed !== 'none') {
        const m = computed.match(/matrix\(([^)]+)\)/);
        if (m) {
          const parts = m[1].split(',').map(Number);
          currentAngle = Math.atan2(parts[1], parts[0]) * (180 / Math.PI);
        }
      }
      setAngle(currentAngle);
    }

    // ─────────────────────────────────────────────────────────────────────────
    // PAGE-LOAD: Ease-Out-Spin (einmalig, 360°)
    // ─────────────────────────────────────────────────────────────────────────
    star.classList.add('star--load-spin');

    star.addEventListener('animationend', function onLoadEnd() {
      star.removeEventListener('animationend', onLoadEnd);
      star.classList.remove('star--load-spin');
      star.classList.add('star--spinning');
    });

    // ─────────────────────────────────────────────────────────────────────────
    // DRAG → SPIN
    // ─────────────────────────────────────────────────────────────────────────

    function onDragStart(e) {
      freezeAngle();
      isDragging      = true;
      angularVelocity = 0;

      const pt = e.touches ? e.touches[0] : e;
      lastX         = pt.clientX;
      lastY         = pt.clientY;
      lastTimestamp = performance.now();

      star.classList.add('star--dragging');

      // Pointer Capture verhindert, dass das Element den Fokus verliert
      if (star.setPointerCapture && e.pointerId != null) {
        star.setPointerCapture(e.pointerId);
      }
    }

    function onDragMove(e) {
      if (!isDragging) return;
      e.preventDefault(); // Seiten-Scroll beim Touch unterdrücken

      const pt  = e.touches ? e.touches[0] : e;
      const cx  = pt.clientX;
      const cy  = pt.clientY;
      const now = performance.now();
      const dt  = now - lastTimestamp || 1;

      // Winkeländerung via Kreuzprodukt der Vektoren vom Mittelpunkt
      const c  = starCenter();
      const v1 = { x: lastX - c.x, y: lastY - c.y };
      const v2 = { x: cx   - c.x, y: cy   - c.y };

      const cross = v1.x * v2.y - v1.y * v2.x;
      const dot   = v1.x * v2.x + v1.y * v2.y;
      const delta = Math.atan2(cross, dot) * (180 / Math.PI);

      currentAngle += delta;
      setAngle(currentAngle);

      // Geglättete Winkelgeschwindigkeit (exponentieller Durchschnitt)
      angularVelocity = angularVelocity * 0.6 + (delta / dt) * 0.4;

      lastX         = cx;
      lastY         = cy;
      lastTimestamp = now;
    }

    function onDragEnd() {
      if (!isDragging) return;
      isDragging = false;
      star.classList.remove('star--dragging');

      // ── Momentum-Coast ────────────────────────────────────────────────────
      const speed = Math.abs(angularVelocity); // Grad/ms

      if (speed > 0.05) {
        const coastDeg      = angularVelocity * 400;                          // ~400 ms Trägheit
        const coastDuration = Math.min(Math.max(speed * 800, 400), 1800);    // 400–1800 ms

        const fromDeg = currentAngle;
        const toDeg   = currentAngle + coastDeg;

        star.style.setProperty('--star-coast-from',     fromDeg       + 'deg');
        star.style.setProperty('--star-coast-to',       toDeg         + 'deg');
        star.style.setProperty('--star-coast-duration', coastDuration + 'ms');

        // inline transform entfernen → @keyframes übernimmt
        star.style.transform = '';
        star.style.animation = '';
        star.classList.add('star--coasting');

        star.addEventListener('animationend', function onCoastEnd() {
          star.removeEventListener('animationend', onCoastEnd);
          star.classList.remove('star--coasting');
          currentAngle = toDeg;
          setAngle(currentAngle);
        });
      }
    }

    // ─────────────────────────────────────────────────────────────────────────
    // EVENT LISTENER  (Pointer API + Touch-Fallback)
    // ─────────────────────────────────────────────────────────────────────────

    // Pointer Events (Desktop + moderne Touch-Geräte)
    star.addEventListener('pointerdown',   onDragStart);
    window.addEventListener('pointermove', onDragMove,  { passive: false });
    window.addEventListener('pointerup',   onDragEnd);
    window.addEventListener('pointercancel', onDragEnd);

    // Touch-Fallback für ältere Browser
    star.addEventListener('touchstart',  onDragStart, { passive: true });
    window.addEventListener('touchmove', onDragMove,  { passive: false });
    window.addEventListener('touchend',  onDragEnd);

  }); // DOMContentLoaded

}());


